import * as angular from 'angular';
import { saveAs } from 'file-saver';
export class FileDownloadService {
  isVisible = false;
  constructor(private $http, private $q, private $timeout, private $window) {
    'ngInject';
  }

  downloadFile(url, customFileName) {
    return this.$http({
      url,
      method: 'GET',
      responseType: 'blob',
      intercept: true // let our global interceptor handle the failure
    })
      .then((data) => {
        // We regex the file name from the headers response and pull it out
        // so that we can use to name dynamically the download file name with the original name it came.
        const fileNameReg = /.*filename="(.*\.[a-z]{3,4})"/i;
        const fileName =
          customFileName ||
          (data.headers('Content-Disposition') || '').replace(
            fileNameReg,
            '$1'
          ) ||
          'aptDownload';

        saveAs(data.data, fileName);
      })
      .catch((er) => {
        throw er;
      });
  }
}
